import React, { Fragment, useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { numberFormater } from '../../helpers/common';
import { colors, graphColors } from '../../helpers/meta';
import PieCore from '../charts/PieCore';
import ColorDot from '../ColorDot';

const GraphCard = ({ parent, childrenLabel, allData }) => {

    const [childrenDate, setChildrenData] = useState([]);
    const [children, setChildren] = useState([]);
    const [data, setData] = useState([]);
    const [peiCoreObject, setPieCoreObject] = useState()
    console.log('peiCoreObject',peiCoreObject);


    useEffect(() => {
        setChildren(childrenLabel)
        setData(allData)

        let pieCoreObject = [];
        children.map((item) => {
            let obj = {
                name : item.label,
                value : Object.keys(allData ? allData : {}).length ?  allData[item.key] : 0,
            }
            pieCoreObject.push(obj)
        })
        setPieCoreObject(pieCoreObject);

    }, [parent, childrenLabel, allData])


    
    return (
        <Fragment>
            <Card  style={{ minHeight: '260px', height: "100%", cursor: 'pointer'  }} >
                <CardBody>
                    <h4 className='mb-0' style={{ fontWeight: 400, fontSize: "16px" }}>{parent.label}</h4>
                   { 
                        peiCoreObject &&
                        <PieCore data={peiCoreObject} />}
                    { children && 
                        children?.map((item, index) => {
                            // console.log('item',item);
                            return (
                                <div className={index == 0 ? 'mt-2' : index == children?.length - 1 ? 'mb-2' : ''} style={{ paddingLeft: "16px", fontSize: "14px", color: colors.lightDark }} key={"visitors-chart-" + index}>
                                    <ColorDot position='absolute' color={graphColors[index]} marginLeft={"-16px"} marginTop='6px' /> {item.label} {''} <span style={{ float: "right" }}>{ }{numberFormater( Object.keys(data ? data : {})?.length ?    data[item?.key] : 0)}</span>

                                </div>
                            )
                        })
                    //      __data.map((val, index) => {
                    //         return (
                    // <div className={index == 0 ? 'mt-2' : index == __data.length - 1 ? 'mb-2' : ''} style={{ paddingLeft: "16px", fontSize: "14px", color: colors.lightDark }} key={"visitors-chart-" + index}>
                    //     <ColorDot position='absolute' color={graphColors[index]} marginLeft={"-16px"} marginTop='6px' /> {val.label} {''} <span style={{ float: "right" }}>{ }{numberFormater(____data[val.key])}</span>
                    // </div>
                    // )
                    //     })
                    }
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default GraphCard;